const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        // marginTop: "25px",
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        paddingTop: "10px",
        paddingBottom: "40px",
    },
});

export default styles;
